module.exports = __webpack_public_path__ + "static/media/microwave.b19971a0.svg";